import * as actionTypes from './actionTypes';

const initState = {
  open : false,
  message :"",
  type:'info'
}
const notificationReducer =  function(state = initState, action){
    switch (action.type) {
      case actionTypes.SUCCESS:
        return {
          ...state,
          open: true,
          message: action.message,
          type:'success'
        };
        case actionTypes.ERROR:
        return {
          ...state,
          open: true,
          message: action.message,
          type:'error'
        };
        case actionTypes.WARNING:
        return {
          ...state,
          open: true,
          message: action.message,
          type:'warning'
        };
        case actionTypes.INFO:
        return {
          ...state,
          open: true,
          message: action.message,
          type:'info'
        };
      case actionTypes.SNACKBAR_CLEAR:
        return {
          ...state,
          open: false,
          message: '',
          type:''
        };
      default:
        return state;
    }
  };

  export default notificationReducer;